import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Divider
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const success = await login(email, password);
      if (success) {
        navigate('/dashboard');
      } else {
        setError('Email sau parolă incorectă');
      }
    } catch (err) {
      setError('A apărut o eroare la autentificare');
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = (demoRole: string) => {
    const demoCredentials = {
      episcop: { email: 'episcop@episcopie.ro', password: 'password123' },
      vicar: { email: 'vicar@episcopie.ro', password: 'password123' },
      paroh: { email: 'paroh@parohia1.ro', password: 'password123' },
      secretar: { email: 'secretar@episcopie.ro', password: 'password123' },
      contabil: { email: 'contabil@episcopie.ro', password: 'password123' }
    };

    const credentials = demoCredentials[demoRole as keyof typeof demoCredentials];
    if (credentials) {
      setEmail(credentials.email);
      setPassword(credentials.password);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography component="h1" variant="h4" color="primary">
              Theofania
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Sistem de administrare Episcopie
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Parolă"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Autentificare'}
            </Button>
          </Box>

          <Divider sx={{ my: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Autentificare demo
            </Typography>
          </Divider>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleDemoLogin('episcop')}
            >
              Episcop (toate permisiunile)
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleDemoLogin('vicar')}
            >
              Vicar
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleDemoLogin('paroh')}
            >
              Paroh
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleDemoLogin('secretar')}
            >
              Secretar
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleDemoLogin('contabil')}
            >
              Contabil
            </Button>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            Parola pentru toate conturile demo: password123
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
